import React, { useEffect } from "react";
import "./RestaurantSetup.css";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import resBlack from "./../../assets/icons/restaurantBlack.png";
import kitchen from "./../../assets/icons/kitchen.png";
import productBlack from "./../../assets/icons/product (1).png";
import empBlack from "./../../assets/icons/Emp.png";
import resTable from "./../../assets/icons/table.png";
import vat from "./../../assets/icons/vat.png";
import userImg from "./../../assets/icons/user.png";
import Leo from "./../../assets/images/Leo.png";
import designaition from "./../../assets/icons/job-description.png";
import bank from "./../../assets/icons/bank.png";
import servicecharge from "./../../assets/icons/customer-service.png";
import subscription from "./../../assets/icons/subscription.png";
import DatatableComponent from "../components/DatatableComponent.tsx";
import CustomDataGrid from "../components/CustomDataGrid/CustomDataGrid.tsx";
import { useNavigate } from "react-router-dom";
import FilterComponents from "../product/components/FilterComponents.tsx";
import RestaurantSetupPage from "./components/RestaurantSetupPage/RestaurantSetupPage.tsx";
import VATSetupPage from "./components/VATSetupPage/VATSetupPage.tsx";
import SideBar from "../layouts/sidebar/SideBar.tsx";
import EmployeeSetupPage from "./components/EmployeeSetupPage/EmployeeSetupPage.tsx";
import ServiceChargeSetupPage from "./components/ServiceChargeSetupPage/ServiceChargeSetupPage.tsx";
import TableSetupPage from "./components/TableSetupPage/TableSetupPage.tsx";
import jwt_decode from "jwt-decode";
import TopHeader from "../../components/TopHeader.tsx";
import KitchenSetupPage from "./components/KitchenSetupPage/KitchenSetupPage.tsx";
import FoodCategorySetupPage from "./components/FoodCategory/FoodCategorySetup.tsx";
import BankDetailsSetup from "./components/BankDetailsSetup/BankDetailsSetup.tsx";
import LoyaltyScheme from "./components/LoyaltyScheme/LoyaltyScheme.tsx";
import loyaltyScheme from "../../assets/images/loyal-customer.png";
import SubscriptionSetup from "../SubscriptionSetup/SubscriptionSetup.tsx";

function RestaurantSetup(props) {
  const navigate = useNavigate();

  const screensByPlan = localStorage.getItem("userScreens");

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [open, setOpen] = React.useState(false);
  const [parentRestaurant, setParentRestaurant] = React.useState(
    JSON.parse(localStorage.getItem("parentrestaurant")),
  );

  const toggleDrawer =
    (anchor: Anchor) => (event: React.KeyboardEvent | React.MouseEvent) => {
      console.log(
        "(event as React.KeyboardEvent).key: " +
          (event as React.KeyboardEvent).key,
      );
      console.log("event: " + event);
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState((prevState) => ({
        ...prevState,
        [anchor]: !prevState[anchor],
      }));
    };
  const clickMenuList = (props) => {
    console.log("props: " + props);
    if (props === "Manage restaurant") {
      navigate("/restaurant-setup");
    } else if (props === "Manage Product") {
      navigate("/manage-product");
    }
  };
  const [tokenData, setTokenData] = React.useState({
    UserName: "",
  });
  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }
  }, []);

  const list = (anchor: Anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        marginTop: 5,
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {["Manage restaurant", "Manage Employee", "Manage Product"].map(
          (text, index) => (
            <ListItem
              key={text}
              disablePadding
              onClick={() => clickMenuList(text)}
            >
              <ListItemButton>
                <ListItemIcon>
                  {index === 0 ? (
                    <img src={resBlack} style={{ width: "1.5rem" }} />
                  ) : index === 1 ? (
                    <img src={empBlack} style={{ width: "1.5rem" }} />
                  ) : (
                    <img src={productBlack} style={{ width: "1.5rem" }} />
                  )}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ),
        )}
      </List>
    </Box>
  );
  const [menuSelection, setMenuSelection] = React.useState(0);
  const changeMenu = (props) => {
    setMenuSelection(props);
  };
  return (
    <div>
      {/* <div className=' d-flex justify-content-between' style={{ height: '3.5rem', backgroundColor: '#56595b' }}>
                <div className='' >
                    <div className='d-flex flex-row'>
                        <div>
                            <SideBar />
                        </div>
                        <h4 className='mt-1' style={{ color: 'white', marginLeft: '1rem' }}>Go <span style={{ color: '#e5e5e5', fontWeight: '700' }}>Taste</span></h4>
                    </div>
                </div>
                <div className='d-flex' style={{ marginRight: '1rem', marginTop: '10px', gap: "10px" }}>
                    <h5 style={{ color: 'white', marginRight: '1rem' }}>Welcome, {tokenData.UserName}</h5>
                    {
                        tokenData.UserImg != undefined ? (
                            <img src={tokenData.UserImg} alt='leo' style={{ width: '2rem', height: '2rem' }} />
                        ) : <img src={userImg} alt='leo' style={{ width: '2rem', height: '2rem' }} />

                    }

                    <h5 style={{ color: 'white', marginRight: '1rem', cursor: "pointer" }} onClick={() => {
                        localStorage.removeItem('gotasteadmintoken');
                        window.location.href = `/`;
                    }}>Log Out</h5>
                </div>


            </div> */}
      <TopHeader />
      <div className="d-flex kycScroll" style={{ overflow: "scroll" }}>
        <div className="d-flex" style={{ width: "107vw" }}>
          <div className="">
            <div className="searchBoxForProduct" style={{ padding: "10px" }}>
              {/* <TextAreaComponents label={"Search"} id={4} /> */}
              <input
                type="text"
                placeholder="Search"
                className="form-control searchBar"
              />
            </div>

            <div
              className="scrollable-div"
              style={{ width: "13rem", height: "100vh" }}
            >
              <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
                <b> Setup</b>
              </h6>
              <hr className="" style={{ margin: ".5rem" }} />

              <div
                className={`restaurant_setup__menuItem ${menuSelection == 0 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(0)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Restaurant Setup
                  </p>
                </div>
              </div>

              <div
                className={`restaurant_setup__menuItem ${menuSelection == 8 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(8)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Food Category Setup
                  </p>
                </div>
              </div>

              <div
                className={`restaurant_setup__menuItem ${menuSelection == 5 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(5)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={kitchen}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Kitchen Setup
                  </p>
                </div>
              </div>
              <div
                className={`restaurant_setup__menuItem ${menuSelection == 1 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(1)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={vat}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    VAT Setup
                  </p>
                </div>
              </div>

              <div
                className={`restaurant_setup__menuItem ${menuSelection == 3 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(3)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={empBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Employee Setup
                  </p>
                </div>
              </div>
              <div
                className={`restaurant_setup__menuItem ${menuSelection == 6 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(6)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resTable}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Table Setup
                  </p>
                </div>
              </div>

              {/* loyalty scheme */}
              {screensByPlan?.includes("Loyalty Scheme") && (
                <div
                  className={`restaurant_setup__menuItem ${menuSelection == 7 ? "active" : ""}`}
                  style={{
                    width: "100%",
                    height: "3rem",
                    transition: "background-color 0.3s",
                  }}
                  onClick={() => changeMenu(7)}
                >
                  <div
                    className=" d-flex justify-content-start align-items-center ms-3"
                    style={{ height: "100%", gap: "10px" }}
                  >
                    <img
                      src={loyaltyScheme}
                      alt="leo"
                      style={{ width: "1.2rem", height: "1.2rem" }}
                    />
                    <p
                      style={{
                        color: "black",
                        fontWeight: "500",
                        marginBottom: "0px",
                        fontSize: "13px",
                      }}
                    >
                      Loyalty Scheme
                    </p>
                  </div>
                </div>
              )}

              <div
                className={`restaurant_setup__menuItem ${menuSelection == 9 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(9)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={bank}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Bank Account Setup
                  </p>
                </div>
              </div>
              {parentRestaurant.ulsHLfS == true && (
                <div
                  className={`restaurant_setup__menuItem ${menuSelection == 10 ? "active" : ""}`}
                  style={{
                    width: "100%",
                    height: "3rem",
                    transition: "background-color 0.3s",
                  }}
                  onClick={() => changeMenu(10)}
                >
                  <div
                    className=" d-flex justify-content-start align-items-center ms-3"
                    style={{ height: "100%", gap: "10px" }}
                  >
                    <img
                      src={subscription}
                      alt="leo"
                      style={{ width: "1.2rem", height: "1.2rem" }}
                    />
                    <p
                      style={{
                        color: "black",
                        fontWeight: "500",
                        marginBottom: "0px",
                        fontSize: "13px",
                      }}
                    >
                      Subcription
                    </p>
                  </div>
                </div>
              )}

              <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
                <b> Form</b>
              </h6>
              <hr className="" style={{ margin: ".5rem" }} />
              <div
                className={`restaurant_setup__menuItem ${menuSelection == 4 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(4)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={empBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Fill Up KYC Form
                  </p>
                </div>
              </div>
            </div>
          </div>
          {menuSelection === 0 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <RestaurantSetupPage />
            </div>
          ) : menuSelection === 1 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <VATSetupPage />
            </div>
          ) : menuSelection === 3 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <EmployeeSetupPage />
            </div>
          ) : menuSelection === 4 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <ServiceChargeSetupPage />
            </div>
          ) : menuSelection === 5 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <KitchenSetupPage />
            </div>
          ) : menuSelection === 6 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <TableSetupPage />
            </div>
          ) : menuSelection === 7 ? (
            <div className="" style={{ marginLeft: "10px", width: "75%" }}>
              <LoyaltyScheme />
            </div>
          ) : menuSelection === 8 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <FoodCategorySetupPage />
            </div>
          ) : menuSelection === 9 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <BankDetailsSetup />
            </div>
          ) : menuSelection === 10 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <SubscriptionSetup />
            </div>
          ) : (
            <p>Coming soon</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default RestaurantSetup;
